import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAdmin, adminApi } from '../context/AdminContext';
import './AdminDashboard.css';

export default function AdminDashboard() {
  const { adminUser } = useAdmin();
  const navigate = useNavigate();
  const [stats, setStats] = useState({ products: 0, subProducts: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminApi.get('/admin/stats')
      .then(res => setStats(res.data))
      .catch(() => setStats({ products: '—', subProducts: '—' }))
      .finally(() => setLoading(false));
  }, []);

  const cards = [
    {
      icon: '🌱',
      label: 'Total Products',
      value: loading ? '...' : stats.products,
      color: '#667eea',
      bg: '#ede9fe',
      action: () => navigate('/admin/products'),
    },
    {
      icon: '🧬',
      label: 'Total Sub Products',
      value: loading ? '...' : stats.subProducts,
      color: '#10b981',
      bg: '#d1fae5',
      action: () => navigate('/admin/sub-products'),
    },
    {
      icon: '🌍',
      label: 'Languages',
      value: 3,
      color: '#f59e0b',
      bg: '#fef3c7',
      action: () => navigate('/admin/content'),
    },
  ];

  return (
    <div className="dashboard-page">
      <div className="dashboard-welcome">
        <div className="welcome-text">
          <h1>Welcome back, {adminUser} 👋</h1>
          <p>Manage your seed company products and content from here.</p>
        </div>
        <div className="welcome-date">
          {new Date().toLocaleDateString('en-IN', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
        </div>
      </div>

      <div className="stats-grid">
        {cards.map((card) => (
          <div
            key={card.label}
            className="stat-card"
            onClick={card.action}
            style={{ '--card-color': card.color, '--card-bg': card.bg }}
          >
            <div className="stat-icon" style={{ background: card.bg }}>
              {card.icon}
            </div>
            <div className="stat-info">
              <div className="stat-value" style={{ color: card.color }}>{card.value}</div>
              <div className="stat-label">{card.label}</div>
            </div>
            <div className="stat-arrow">→</div>
          </div>
        ))}
      </div>

      <div className="dashboard-quick-actions">
        <h2>Quick Actions</h2>
        <div className="quick-grid">
          <button className="quick-btn" onClick={() => navigate('/admin/products')}>
            <span>🌱</span> Add Product
          </button>
          <button className="quick-btn" onClick={() => navigate('/admin/sub-products')}>
            <span>🧬</span> Add Sub Product
          </button>
          <button className="quick-btn" onClick={() => navigate('/admin/content')}>
            <span>✏️</span> Manage Content
          </button>
          <button className="quick-btn" onClick={() => window.open('/', '_blank')}>
            <span>🌐</span> View Website
          </button>
        </div>
      </div>
    </div>
  );
}
